var _style, _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 254.8 123.5",
    style: {
      enableBackground: "new 0 0 254.8 123.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000163044473505152442000000010251776685609823904_);}\n\t.st1{fill:#673AB7;}\n\t.st2{fill:#AADB23;}\n\t.st3{fill:#7B9E19;}\n\t.st4{fill:#617D14;}\n\t.st5{fill:#475C0F;}\n\t.st6{opacity:0.901;fill:url(#Rectangle_174-2_00000077305218452904253060000010214165582435171235_);enable-background:new    ;}\n\t.st7{opacity:0.901;}\n\t.st8{fill:url(#SVGID_00000152946825340839852510000014005312944038833315_);}\n\t.st9{fill:none;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M18.4,0h218.1c10.1,0,18.4,8.2,18.4,18.4v86.8c0,10.1-8.2,18.3-18.4,18.3H18.4C8.2,123.5,0,115.3,0,105.2 V18.4C0,8.2,8.2,0,18.4,0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077295411138828444850000005840671928986262179_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_by_Rectangle",
    style: {
      clipPath: "url(#SVGID_00000077295411138828444850000005840671928986262179_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_by_Rectangle-2",
    transform: "translate(-316.271 -241.304)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 316.3,
    y: 241.3,
    className: "st1",
    width: 254.8,
    height: 138.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "st2",
    cx: 316.2,
    cy: 241.2,
    rx: 316.2,
    ry: 241.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_3",
    className: "st3",
    cx: 316.2,
    cy: 241.2,
    rx: 229.8,
    ry: 175.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_2",
    className: "st4",
    cx: 316.2,
    cy: 241.3,
    rx: 161.3,
    ry: 123.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy",
    className: "st5",
    cx: 316.2,
    cy: 241.2,
    rx: 89,
    ry: 67.9
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_174-2_00000139264308563273898850000001211630749733881760_",
    gradientUnits: "userSpaceOnUse",
    x1: -410.2505,
    y1: 420.5682,
    x2: -411.0079,
    y2: 421.313,
    gradientTransform: "matrix(350 0 0 -145 143848.5 61098.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#502C84",
      stopOpacity: 0.404
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.141
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_174-2",
    style: {
      opacity: 0.901,
      fill: "url(#Rectangle_174-2_00000139264308563273898850000001211630749733881760_)",
      enableBackground: "new"
    },
    d: " M13,0h228.8c7.2,0,13.1,6.9,13.1,15.3v92.9c0,8.5-5.9,15.3-13.1,15.3H13c-7.2,0-13.1-6.9-13.1-15.3V15.3C-0.1,6.9,5.8,0,13,0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_174-2_00000022522838866512434840000013793889685624338332_",
    transform: "translate(60 60)",
    className: "st7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031900014168783183990000002603414333586556047_",
    gradientUnits: "userSpaceOnUse",
    x1: -469.6385,
    y1: 360.115,
    x2: -470.5956,
    y2: 361.0559,
    gradientTransform: "matrix(255 0 0 -123.889 119948 44674.707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#502C84",
      stopOpacity: 0.404
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.141
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031900014168783183990000002603414333586556047_)"
    },
    d: "M-42.1-60.2h219c9.9,0,18,8.1,18,18v87.9 c0,9.9-8.1,18-18,18h-219c-9.9,0-18-8.1-18-18v-87.9C-60.1-52.1-52-60.2-42.1-60.2z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-42.1-59.7h219c9.7,0,17.5,7.8,17.5,17.5v87.9c0,9.7-7.8,17.5-17.5,17.5h-219c-9.7,0-17.5-7.8-17.5-17.5 v-87.9C-59.6-51.8-51.8-59.7-42.1-59.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBg);
export default __webpack_public_path__ + "static/media/green-bg.fa3e6cd7a59648dd74fe35cd9e249d83.svg";
export { ForwardRef as ReactComponent };